<template>
  <div
    class="compact-topic-card"
    :class="{
      'is-draggable': isDraggable,
      'is-clickable': !isDraggable,
      'is-dragging': isDragging,
      'is-highlighted': !!usage,
      'is-selected': isSelected,
      'is-private': topic.isPublic === false,
    }"
    :draggable="isDraggable"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
    @click="$emit('click', topic)"
  >
    <!-- Remove button -->
    <b-button
      v-if="canRemove"
      class="remove-button"
      type="is-danger is-light"
      icon-left="trash"
      size="is-small"
      @click.stop="$emit('remove', topic.id)"
    />

    <!-- Topic title with lock icon for private topics -->
    <div class="topic-title">
      <b-icon
        v-if="topic.isPublic === false"
        icon="lock"
        size="is-small"
        class="mr-1"
      />
      <b-tooltip
        :label="topic.description || topic.title"
        position="is-bottom"
        multilined
        size="is-small"
      >
        <span class="has-text-weight-semibold">{{ topic.title }}</span>
      </b-tooltip>
    </div>

    <!-- Difficulty badge -->
    <DifficultyBadge
      v-if="topic.difficultyLevel"
      :difficulty="topic.difficultyLevel"
    />

    <!-- Optional tag -->
    <b-tag v-if="topic.isOptional" type="is-light" size="is-small">
      optional
    </b-tag>
  </div>
</template>

<script>
import DifficultyBadge from "../atoms/DifficultyBadge.vue";

export default {
  name: "CompactTopicCard",

  components: {
    DifficultyBadge,
  },

  props: {
    topic: { type: Object, required: true },
    usage: { type: String, default: null },
    canRemove: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false },
    isDraggable: { type: Boolean, default: true },
  },

  data() {
    return {
      isDragging: false,
    };
  },

  methods: {
    handleDragStart(event) {
      if (!this.isDraggable) return;

      this.isDragging = true;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", JSON.stringify(this.topic));
    },

    handleDragEnd() {
      this.isDragging = false;
    },
  },
};
</script>

<style scoped>
.compact-topic-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  background-color: white;
  transition: all 0.2s ease;
  min-height: 40px;
}

.topic-title {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  line-height: 1.2;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-button {
  opacity: 0;
  transition: opacity 0.2s ease;
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  height: 1.5rem;
  width: 1.5rem;
  padding: 0;
}

.compact-topic-card:hover .remove-button {
  opacity: 1;
}

.compact-topic-card.is-draggable {
  cursor: grab;
}

.compact-topic-card.is-clickable {
  cursor: pointer;
}

.compact-topic-card.is-highlighted {
  border-color: #00d1b2;
  background-color: rgba(0, 209, 178, 0.05);
}

.compact-topic-card:hover {
  border-color: #34369e;
  box-shadow: 0 2px 4px rgba(10, 10, 10, 0.1);
  transform: translateY(-2px);
}

.compact-topic-card.is-dragging {
  opacity: 0.5;
  cursor: grabbing;
}

.compact-topic-card.is-selected {
  border-color: #3273dc; /* Buefy blue */
}

.compact-topic-card.is-private {
  background-color: rgba(255, 221, 87, 0.05);
}
</style>
